import React, { memo } from 'react'

const SubHeader = memo(() => {
    return (
        <div style={{ height: '45px', backgroundColor: '#f8f9fd' }}>
        </div>
    )
})

export default SubHeader
